export class InsuredTripTravelCardRequest {
    id: number = (new Date()).getTime();
    type: string = 'travel_card';
    policyNumber: string;
    dateBegin: string;
    dateEnd: string;
    firstName: string;
    surname: string;
    dateOfBirth: string;
}
